import { types } from '../constants'

const index = {
  pending: `${types.update}_PENDING`,
  fulfilled: `${types.update}_FULFILLED`,
  rejected: `${types.update}_REJECTED`
}

export const update = {
  [index.pending]: ({ draft }) => {
    draft.campaign.update.loading = true
    draft.campaign.update.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    // draft.campaign.item = action.payload.updated;
    draft.campaign.update.loading = false
    draft.campaign.update.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.campaign.update.loading = false
    draft.campaign.update.error = action.payload
  }
}
